import { gql } from '@apollo/client';

export * from './agreementApprove.mutation.generated';

export const AGREEMENT_APPROVE = gql`
  mutation agreementApprove($escrowId: ID!) {
    agreementApprove(input: { escrowId: $escrowId }) {
      success
      errors
      escrow {
        id
        status
        agreement {
          id
        }
      }
    }
  }
`;
